<template>
  <div class="pharmacy-drugs">
    <el-form ref="form" :model="filters" label-width="80px" inline>
      <el-form-item label="药房名称" prop="hosName">
        <el-input v-model="hosName" disabled></el-input>
      </el-form-item>
      <el-form-item label="药品名称" prop="drugName">
        <el-input v-model="filters.drugName" placeholder="请输入药品名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getList">筛选</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleChangeStockStatus(true)">标记为有药</el-button>
        <el-button type="primary" @click="handleChangeStockStatus(false)">标记为缺药</el-button>
      </el-form-item>
    </el-form>
    <el-radio-group v-model="checkedStatus">
      <el-radio-button v-for="state in states" :label="state.label" :key="state.text">{{ state.text }}
      </el-radio-button>
    </el-radio-group>
    <el-table :data="list" v-loading="loading" border @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column
          :formatter="formatterDrugType"
          prop="drugInfo.drugType"
          label="药品类型"
          width="180"
      ></el-table-column>
      <el-table-column prop="drugInfo.drugCode" label="药品编号"></el-table-column>
      <el-table-column prop="drugInfo.drugName" label="药品名称"></el-table-column>
      <el-table-column prop="drugInfo.drugEnglishName" label="药品英文名"></el-table-column>
      <el-table-column prop="drugInfo.drugSpecification" label="规格"></el-table-column>
      <el-table-column prop="drugInfo.drugUnit" label="单位"></el-table-column>
      <el-table-column prop="drugInfo.price" :formatter="formatPrice" label="平台价格（元）"></el-table-column>
      <el-table-column prop="isHave" :formatter="formatIsHave" label="库存状态"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="primary" size="small" @click="onView(scope.row)">查看详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-row class="pagination-wrapper" type="flex" justify="end">
      <el-pagination
          layout="prev, pager, next"
          :current-page.sync="page.pageNum"
          :total="page.total"
          @current-change="onCurrentChange"
      ></el-pagination>
    </el-row>
    <pharmacy-drugs-detail :visible.sync="visible" @close="getList" :drugInfo="drugInfo"></pharmacy-drugs-detail>
  </div>
</template>

<script lang="es6">
import PharmacyDrugsDetail from "./detail";
import {timeFormat, sex} from "ty-vue-filters";
import {tokenCache} from "../../lib/cache/Token";
import {RECIPE_TYPE} from "@/lib/config";

const PAGE = {
  pageNum: 1,
  pageSize: 10,
  pages: 1,
  total: 0
};
export default {
  data() {
    return {
      visible: false,
      options: [],
      hosName: "",
      drugInfo: {},
      filters: {
        hosName: "",
        drugName: ""
      },
      checkedStatus: true,
      list: [],
      multipleSelection: [],
      states: [
        {
          label: true,
          text: "可开具"
        },
        {
          label: false,
          text: "无库存"
        }
      ],
      loading: false,
      page: PAGE
    };
  },
  components: {
    PharmacyDrugsDetail
  },
  watch: {
    checkedStatus: {
      handler() {
        this.pages = PAGE;
        this.getList();
      },
      immediate: true
    }
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    async handleChangeStockStatus(haveDrug) {
      if (this.multipleSelection.length <= 0) {
        this.$message.error('请至少勾选一个药品！')
        return
      }
      const drugIdList = this.multipleSelection.map(v => v.drugId);
      const options = {
        drugIdList,
        haveDrug,
        token: tokenCache.get(),
      }
      const {code, list, page, msg} = await this.$http('smarthos.recipe.hosdrug.batch.save', options)
      if (code === "0") {
        this.$message.success("修改库存状态成功");
        this.getList();
      } else {
        this.$message.error(msg);
      }
    },
    onView(row) {
      this.drugInfo = Object.assign(row.drugInfo, {
        isHave: row.isHave,
        drugId: row.drugId
      });
      this.visible = true;
    },
    onCurrentChange(pageNum) {
      this.page.pageNum = pageNum;
      this.getList();
    },
    async getList() {
      this.loading = true;
      const options = {
        token: tokenCache.get(),
        haveDrug: this.checkedStatus,
        ...this.page,
        ...this.filters
      }
      const {code, list, page, msg} = await this.$http('smarthos.recipe.hosdrug.list.page', options)
      if (code === "0") {
        this.loading = false;
        this.list = list;
        this.page = page;
      } else {
        this.$message.error(msg);
      }
    },
    formatIsHave(row, column, isHave) {
      return isHave ? "有库存" : "暂无库存";
    },
    formatterDrugType(row, column, code) {
      const types = {
        PATENT_MEDICINE: "成药",
        HERBAL_MEDICINE: "草药",
        WESTERN_MEDICINE: "西药"
      };
      return types[code];
    },
    formatterCompatGender(row, column, code) {
      return sex(code, 2);
    },
    formatPrice(row, column, price) {
      return parseFloat(price / 100);
    },
    formatterStatus({takeMode}, column, status) {
      let result = "";
      const self = takeMode === "SELF";
      if (status === "PAY" && self) {
        result = "待自取";
      } else if (status === "SHIPPING" && self) {
        result = "已发药";
      } else if (status === "COMPLETE" && self) {
        result = "已取药";
      } else if (status === "COMMENT") {
        result = "已取药";
      }
      return result;
    },
    formatterOrderType(row, column, code) {
      const typeObj = RECIPE_TYPE;
      return typeObj[code];
    },
    formatterPrescribingInformation({drugCount, totalPrice}) {
      return `${drugCount}种药品 ${totalPrice}元`;
    }
  },
  created() {
    const userInfo = JSON.parse(window.localStorage.getItem("userInfo")) || {};
    this.hosName = userInfo.doc && userInfo.doc.hosName;
  }
};
</script>

<style lang="scss">
.pharmacy-drugs {
  .el-table {
    margin-top: 15px;
  }

  .pagination-wrapper {
    padding: 20px 0;
  }

  .el-table .cell {
    max-height: 69px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  }
}
</style>
